<template>
    <div
        :class="[
            'DshFormItem',
            { 'DshFormItem-required': formItem._required },
            { 'DshFormItem-line': formItem._line },
            `DshFormItem-${formItem._type}`,
            formControlClass,
        ]"
        :style="{
            width: `calc(${(formItem._br ? (formItem._span || 24)/24 : 1) * 100}% - 12px)`,
            height: formItem._br || (formItem._span || 24) === 24 ? undefined : `${height}px`,
            minHeight: `${46}px`,
            alignItems: formItem._labelAlignItems || 'center',
            ...rowStyle
        }"
    >
        <!-- label -->
        <div
            v-if="!formItem._noLabel"
            class="DshFormItem-label"
            :style="[
                labelStyle,
                { justifyContent: formItem._labelAlign }
            ]"
        >
            <span class="DshFormItem-label-left" :style="labelLeftStyle">
                <Ctooltip
                    :content="formItem._name"
                    transfer
                    style="height: 14px"
                >
                    <span class="DshFormItem-label-name dsh-ellipsis">
                       <slot name="label">{{ formItem._name }}</slot>
                    </span>
                </Ctooltip>
            </span>

            <span class="DshFormItem-label-right">
                <slot name="extra">
                    <Ctooltip
                        :content="formItem._description"
                        transfer
                        style="height: 14px;"
                    >
                        <span class="DshFormItem-label-description dsh-ellipsis">
                            {{ formItem._description && `* ${formItem._description}` }}
                        </span>
                    </Ctooltip>
                </slot>
            </span>
        </div>

        <!-- 控件 -->
        <div class="DshFormItem-control"
            :style="{
                justifyContent: formItem._controlAlign
            }"
        >
            <!-- 控件位置放置的dom -->
            <slot name="control"></slot>

            <slot>
                <component
                    :is="componentNameMap[formItem._type] || 'DshUndeveloped'"
                    :mode="mode"
                    :isShare="isShare"
                    :canEdit="canEdit"
                    :value="formData"
                    :propsObj="formItem"
                    :allFormList="allFormList"
                    @change="change"
                    @changeField="changeField"
                ></component>
            </slot>
        </div>

        <!-- 角插槽 -->
        <slot name="corner"></slot>
    </div>
</template>

<script>
    import unitMixin from "./unitMixin.js";

    export default {
        name: "DshFormItem",
        mixins: [unitMixin],
        props: {
            // 实际最精确值是74px（label:30px, control:32px, 上下padding各: 6px，因为ivu-form-item-content里line-height: 32px导致有问题，故先76px
            height: {
                type: [String, Number],
                default: "74"
            },
            labelWidth: [String, Number],
            labelPosition: {
                type: String,
                default: "right"
            },
            rowStyle: Object,
            formControlClass: String,
            isShare: Boolean
        },
        data () {
            return {};
        },
        computed: {
            labelStyle () {
                return {
                    width: this.labelWidth + "px"
                    // textAlign: this.labelPosition
                    // marginRight: "20px"
                };
            },
            labelLeftStyle () {
                return {
                    minWidth: this.labelWidth + "px"
                };
            }
        },
        created () {
        },
        methods: {
            changeField (...params) {
                this.$emit("changeField", ...params);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/unit/DshFormItem.vue